import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c('core-tags', {
    attrs: {
      "tags": _vm.tags,
      "label": _vm.$i18n_t('Common.tags'),
      "additional-items": _vm.dashboardParametersAsSelectItems,
      "tag-list-type": "virtualDevice"
    },
    on: {
      "update:tags": function ($event) {
        _vm.tags = $event;
      }
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "multiple": "",
      "value": _vm.selectionForParentTwinsInput,
      "items": _vm.parentTwinSearchItems,
      "loading": _vm.isSearchingParentTwins,
      "search-input": _vm.parentTwinSearchString,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.virtualDeviceFilterEditor.parentTwinInputLabel'),
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.parentTwinSearchString = $event;
      },
      "update:search-input": function ($event) {
        _vm.parentTwinSearchString = $event;
      },
      "change": _vm.setParentTwinSelection
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "multiple": "",
      "value": _vm.selectionForVdInput,
      "items": _vm.vdSearchItems,
      "loading": _vm.isSearchingVds,
      "search-input": _vm.vdSearchString,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.virtualDeviceFilterEditor.inputLabel'),
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.vdSearchString = $event;
      },
      "update:search-input": function ($event) {
        _vm.vdSearchString = $event;
      },
      "change": _vm.setVdSelection
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };